export default "__VITE_ASSET__CMej83qx__"